import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Teklifler = () => {
  const navigate = useNavigate();
  const [teklifler, setTeklifler] = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [tekliflerRes, musterilerRes] = await Promise.all([
        axios.get(`${API}/teklifler`),
        axios.get(`${API}/musteriler`)
      ]);
      setTeklifler(tekliflerRes.data);
      setMusteriler(musterilerRes.data);
    } catch (error) {
      console.error('Veriler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu teklifi silmek istediğinize emin misiniz?')) {
      try {
        await axios.delete(`${API}/teklifler/${id}`);
        fetchData();
      } catch (error) {
        console.error('Teklif silinirken hata:', error);
        alert('Teklif silinemedi');
      }
    }
  };

  const getMusteriAdi = (musteri_id) => {
    const musteri = musteriler.find(m => m.id === musteri_id);
    return musteri ? musteri.ad : '-';
  };

  const calculateTotal = (teklif) => {
    const subtotal = teklif.kalemler.reduce((sum, item) => sum + (item.miktar * item.birim_fiyat), 0);
    const kdv = subtotal * (teklif.kdv_orani / 100);
    return subtotal + kdv;
  };

  const printProforma = async (teklif_id) => {
    try {
      const response = await axios.get(`${API}/print/proforma/${teklif_id}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `proforma_${teklif_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Proforma oluşturulurken hata:', error);
      alert('Proforma oluşturulamadı');
    }
  };

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  return (
    <div data-testid="proposals-page">
      <div className="page-header">
        <h1 className="page-title">Teklifler</h1>
        <p className="page-subtitle">Teklif kayıtlarını görüntüleyin ve yönetin</p>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <button className="btn btn-primary" onClick={() => navigate('/teklifler/yeni')} data-testid="add-proposal-btn">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Yeni Teklif
        </button>
      </div>

      {teklifler.length === 0 ? (
        <div className="empty-state" data-testid="empty-state">
          <h3>Henüz teklif kaydı yok</h3>
          <p>Yeni teklif eklemek için yukarıdaki butona tıklayın</p>
        </div>
      ) : (
        <div className="card">
          <table className="table" data-testid="proposals-table">
            <thead>
              <tr>
                <th>Teklif No</th>
                <th>Müşteri</th>
                <th>Tarih</th>
                <th>Toplam Tutar</th>
                <th>Geçerlilik</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {teklifler.map(teklif => (
                <tr key={teklif.id} data-testid={`proposal-row-${teklif.id}`}>
                  <td style={{ fontWeight: 600 }}>{teklif.teklif_no}</td>
                  <td>{getMusteriAdi(teklif.musteri_id)}</td>
                  <td>{new Date(teklif.tarih).toLocaleDateString('tr-TR')}</td>
                  <td>{calculateTotal(teklif).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {teklif.para_birimi}</td>
                  <td>{teklif.gecerlilik} gün</td>
                  <td>
                    <div className="action-buttons">
                      <button className="icon-btn" onClick={() => printProforma(teklif.id)} title="Proforma Yazdır" data-testid={`print-proforma-${teklif.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                        </svg>
                      </button>
                      <button className="icon-btn" onClick={() => navigate(`/teklifler/${teklif.id}`)} data-testid={`edit-proposal-${teklif.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </button>
                      <button className="icon-btn danger" onClick={() => handleDelete(teklif.id)} data-testid={`delete-proposal-${teklif.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Teklifler;